export function createDedupedRefresh(fn: () => Promise<string | null>) {
  let refreshPromise: Promise<string | null> | null = null;

  return async () => {
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = (async () => {
      try {
        return await fn();
      } finally {
        refreshPromise = null;
      }
    })();

    return refreshPromise;
  };
}
